<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="7" md="5" class="pb-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
          <v-icon>
              mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" sm="4" class="pa-0 mr-5">
          <v-select
            dense
            v-model="filters.defaultTab"
            :items="defaultTabFilter"
            :menu-props="{ maxHeight: '400' }"
            label="Default page"
            multiple
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" class="pa-0 mr-auto">
          <v-select
            dense
            v-model="filters.numberOfOwners"
            :items="numberOfOwnersFilter"
            :menu-props="{ maxHeight: '400' }"
            label="Number of owners"
            multiple
            outlined
            class="pa-0"
          ></v-select>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
        <v-data-table
          :headers="headers"
          :items="dataFiltered"
          item-key="uid"
          :search="search"
          :loading="loaded"
          loading-text="Loading... Please wait"
          id="datatable"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex flex-column">
              <v-icon
                  small           
                  @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </div>
          </template>
        </v-data-table>
         <v-dialog v-model="dialogEditCompany" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Company Settings</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    type="text"
                    disabled
                    outlined 
                    dense   
                    :value="companySettingsForm.name"
                    label="Company Name"
                    class="my-0 pa-0"
                    hide-details
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">    
                  <v-select
                    dense
                    :items="availableModules"
                    v-model="companySettingsForm.uiSettings.availableTabs"
                    :menu-props="{ maxHeight: '400' }"
                    label="Select the available modules"
                    multiple
                    outlined
                    hide-details
                    chips
                    class="chip"
                    show-select
                    @change="cleanDefaultTab"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Select the available modules
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">    
                  <v-select
                    dense
                    :items="availableDefaultPages"
                    item-text="text"
                    item-value="value"
                    v-model="companySettingsForm.uiSettings.defaultTab"
                    :menu-props="{ maxHeight: '400' }"
                    label="Default page"
                    outlined
                    class="pa-0"
                    hide-details
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>Default page
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-img
                    :src="companySettingsForm.logo"
                    class="indigo"
                    :eager="true"
                  ></v-img>
                </v-col>
                <v-col cols="12" class="d-flex">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        class="mr-2"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>Please upload image with Max width = 200px and Max height = 38px</span>
                  </v-tooltip>
                  <v-file-input
                    v-model="logoFile"
                    dense
                    label="Edit the company logo"
                    outlined
                    append-icon="mdi-plus"
                    prepend-icon=""
                    hide-details
                    @change="convertToBase64"
                    :value="logoName"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancelCompany">Cancel</v-btn>
            <v-btn color="blue darken-1" text :disabled="validationEditCompany" @click="saveCompany">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'

export default {
  name: 'company-management',
  data() {
    return {
      companies: [],
      headers: [
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
        {text: 'Company Name', value: 'name', class: 'black--text'},
        {text: 'Default page', value: 'defaultTab', class: 'black--text'},
        {text: 'Number of users', value: 'numberOfOwners', class: 'black--text'},
        {text: 'Last edit date', value: 'lastEditDate', class: 'black--text'},
      ],
      search: '',
      defaultPage: [],
      numberOwners: [],
      filters: {
        'defaultTab': [],
        'numberOfOwners': [],
      },
      dialogEditCompany: false,
      companySettingsForm: {
        logo: [],
        uiSettings: {
          availableTabs: []
        },
        name: ''
      },
      loaded: false,
      availableModules: [
        "marketing",
        "sales",
        "executive",
        "administration",
        "reports"
      ],
      listDefaultPages: [
        {text: 'Marketing Activity', value: 'marketing-summary', group: 'marketing'},
        {text: 'Marketing Channel Attribution', value: 'marketing-attribution', group: 'marketing'},
        {text: 'Email Marketing Attribution', value: 'email-campaigns-attribution', group: 'marketing'},
        {text: 'Marketing Report', value: 'marketing', group: 'marketing'},
        {text: 'Campaigns', value: 'campaigns', group: 'marketing'},
        {text: 'Cruise Campaigns', value: 'cruise-campaigns', group: 'marketing'},
        {text: 'Keywords Report', value: 'keywords-report', group: 'marketing'},
        {text: 'Keyword Attribution', value: 'keyword-attribution', group: 'marketing'},

        {text: 'Sales Report', value: 'sales', group: 'sales'},
        {text: 'Geo Sales Report', value: 'geo-sales', group: 'sales'},
        {text: 'Customers', value: 'customers', group: 'sales'},
        {text: 'Sales Activity per Geo Area', value: 'monthly-state-activity', group: 'sales'},
        {text: 'Gallons Activity', value: 'gallons', group: 'sales'},
        {text: 'CRM Report', value: 'crm-report', group: 'sales'},
        {text: 'CRM Customers', value: 'crm-customers', group: 'sales'},
        {text: 'Potential Quotes', value: 'potential-gallon', group: 'sales'},

        {text: 'Monthly Activity', value: 'monthly-activity', group: 'executive'},
        {text: 'General Metrics Overview ', value: 'general-metrics', group: 'executive'},
        {text: 'Call Center', value: 'call-center', group: 'executive'},
        {text: 'CallRail Report', value: 'call-report', group: 'executive'},
        {text: 'Cost per Gallon', value: 'cost-per-gallon', group: 'executive'},

        {text: 'Call and Web Inquires Report', value: 'callrail', group: 'reports'},
        {text: 'Web inquiries Report', value: 'web-inquiries-report', group: 'reports'},

        {text: "FO Contacts", value:'fo-contacts', group: 'rural'},
        {text: "Applicators", value:'fo-contacts', group: 'rural'},
        {text: "Building Arhitect", value:'building-arhitect', group: 'rural'},
      ],
      logoName: [],
      logoFile: []
    }
  },
  mounted() {
    this.getCompanies()
  },
  computed: {
    numberOfOwnersFilter(){
      let data = this.companies.map(e => e.numberOfOwners).filter((x, i, a) => a.indexOf(x) == i)
                .sort((a, b) => a - b)
      return this._.compact(data)
    },
    defaultTabFilter(){
      let data = this.companies.map(e => e.defaultTab).filter((x, i, a) => a.indexOf(x) == i)
          .sort((a, b) => a.localeCompare(b))
      return this._.compact(data)
    },
    dataFiltered(){
      return this.companies.filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    },
    availableDefaultPages(){
      return this.listDefaultPages.filter(e => this.companySettingsForm.uiSettings.availableTabs.includes(e.group))
    },
    validationEditCompany(){
      return !this.companySettingsForm.uiSettings.availableTabs ||
             this.companySettingsForm.uiSettings.availableTabs.length === 0 ||
             !this.companySettingsForm.uiSettings.defaultTab
    }
  },
  methods: {
    getCompanies(){
      this.loaded = true
      axios
      .get('/companies')
      .then(response => {
        this.companies = response.data.data
        this.companies.map(e => e.defaultTab = this.listDefaultPages.find(i => i.value === e.uiSettings.defaultTab).text)
      
        this.loaded = false
      })
    },
    cleanFilters(){
      this.search = ''

      this.filters.defaultPage = []
      this.filters.numberOwners = []
    },
    edit(item){
      this.logoName = []
      this.logoFile = []
      this.companySettingsForm = JSON.parse(JSON.stringify(item))

      this.dialogEditCompany = true
    },
    cancelCompany(){
      this.dialogEditCompany = false
    },
    convertToBase64(file){
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.companySettingsForm.logo = reader.result
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    },
    saveCompany(){
          axios({
            url: '/companies/settings',
            method: 'put',
            data: {
              logo: this.companySettingsForm.logo, 
              uiSettings: this.companySettingsForm.uiSettings, 
              name: this.companySettingsForm.name,
              id: this.companySettingsForm.id
              }
          }).then(response => {
              console.log('response Save Company', response.data)
              this.companySettingsForm = {}
              this.dialogEditCompany = false
              window.location.reload()
            })
    },
    cleanDefaultTab(){
      this.companySettingsForm.uiSettings.defaultTab = null
    }
  }
}

</script>

<style scoped>
  .chip::v-deep .v-chip {
    border-radius: 16px;
    font-size: 13px;
    height: 20px !important;
    color: white;
    background-color: #BDBDBD;
    margin: 4px 4px 0px 4px;
}
</style>
